//
//
//
//
//
//
//
//
//

import HiHeader from "../../../components/header/Index.vue";
import HiCell from "../../../components/cell/Index.vue";
import PlanPricingPackage from "../../../components/active/pricing_package/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../../store/mutation-types";

export default {
  name: "PlanUpgradeComponent",
  components: { HiHeader, HiCell, PlanPricingPackage },
  methods: {
    /**
     * 点击跳转到升级页面
     */
    cellClick() {
      this.$router.push({
        name: "PaymentUpgradePage",
        params: { type: "filter" },
      });
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/components/plan/upgrade/Index.vue